import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Reminder-email landing: pick up a submitted-but-unpaid listing and go to checkout.
export default function CreateListingPay() {
  const { claimId } = useParams();
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${API}/public/create-listing/resume/${claimId}`).then((r) => setInfo(r.data)).catch(() => setInfo(false)); }, [claimId]);

  const pay = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/public/claim/${claimId}/checkout`, {});
      if (data.free && data.set_password_token) { window.location.href = `/claim/set-password?token=${data.set_password_token}`; return; }
      window.location.href = data.url;
    } catch { toast.error('Could not start checkout'); setBusy(false); }
  };

  return (
    <div className="bg-[#F4F7F9] min-h-[70vh] px-4 py-16" data-testid="create-listing-pay">
      <div className="max-w-md mx-auto bg-white border border-[#E5E7EB] rounded-xl p-7">
        {info === null && <Loader2 className="w-6 h-6 animate-spin text-gray-400 mx-auto" />}
        {info === false && <p className="text-gray-600">We couldn't find that listing. <Link to="/create-listing" className="text-[#00857D] font-semibold">Start a new one</Link>.</p>}
        {info && info.paid && <p className="text-gray-700" data-testid="clp-paid">Good news - <b>{info.supplier_name}</b> is already paid. Check your email for your password link, or <Link to="/portal" className="text-[#00857D] font-semibold">log in to the portal</Link>.</p>}
        {info && !info.paid && (
          <>
            <h1 className="font-heading text-2xl font-extrabold text-gray-900">Finish your listing</h1>
            <p className="text-gray-600 mt-2 text-sm">Your details for <b>{info.supplier_name}</b> are saved. Complete payment and we'll check and publish your listing.</p>
            <div className="border border-[#E5E7EB] rounded-lg px-4 py-3 mt-5 flex justify-between text-sm">
              <span className="text-gray-600 capitalize">{info.band_label} · {info.plan}</span>
              <span className="font-bold text-gray-900" data-testid="clp-amount">£{info.amount}</span>
            </div>
            <button onClick={pay} disabled={busy} data-testid="clp-pay"
              className="w-full mt-5 inline-flex items-center justify-center gap-2 bg-[#00A79D] hover:bg-[#00857D] text-[#ffffff] font-semibold py-3 rounded-md disabled:opacity-60 transition-colors">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Continue to secure payment <ArrowRight className="w-4 h-4" /></>}
            </button>
            <p className="text-xs text-gray-400 mt-3 text-center">Need to change something? <Link to="/create-listing" className="text-[#00857D]">Fill in the form again</Link>.</p>
          </>
        )}
      </div>
    </div>
  );
}
